/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-children-prop */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement, useEffect, useState } from 'react';
import { Box, Button, Grid, Modal, Typography } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import useStyles from '../../../assets/styles/components/Modals';

import { ReactComponent as IconUser } from '../../../assets/images/svg/sign_up/icon_user.svg';
import { ReactComponent as IconEmail } from '../../../assets/images/svg/sign_up/icon_email.svg';
import { ReactComponent as IconPhone } from '../../../assets/images/svg/sign_up/icon_phone.svg';
import { ReactComponent as IconArrowRight } from '../../../assets/images/svg/shops/request/icon_seta_direita.svg';

import Header from '../../Header';

import { ItypeReturnApi } from '../../../helpers/utils/TypeReturnApi';
import { api } from '../../../services';
import { useLoadingContext } from '../../../providers/use-loading';
import { getStorege } from '../../../helpers/db_storage';
import { ListCenterOrder } from '../ListCenterOrder';
import { ModalMessage } from '../Message';
import { onlyNumbers } from '../../../helpers/utils/Formating';

const styleModal = {
  width: '100%',
  height: '100%',
  maxWidth: 680,
  bgcolor: 'background.paper',
  outline: 'none',
  overflowY: 'auto',
};

type Props = {
  isOpen: boolean;
  dataOrder: any;
  dataShop: any;
  fn: (data: any) => void;
  onClose: () => void;
  icon?: any;
};

const OrderDataRegister = ({
  isOpen,
  dataOrder,
  dataShop,
  fn,
  onClose,
  icon = <IconUser width={35} height={35} />,
}: Props): ReactElement => {
  const classeStyle = useStyles();
  const { createloading } = useLoadingContext();
  const navigate = useNavigate();

  const [formParams, setFormParams] = useState({
    dsNome: '',
    nrDDD: '',
    nrTelefone: '',
    dsEmail: '',
    idCidade: 0,
    dsCidade: '',
    dsEstado: '',
    nrLatitude: 0,
    nrLongitude: 0,
    nrLatitudeCidade: 0,
    nrLongitudeCidade: 0,
    dsRua: '',
    nrRua: '',
    dsComplemento: '',
    dsReferencia: '',
    idBairro: 0,
    dsBairro: '',
    idUsuario: 0,
    idEndereco: 0,
    complet: 'complet',
  });

  const [destrictList, setDestrictList] = useState<any>();
  const [openModalSelectDistrict, setOpenModalSelectDistrict] = useState(false);
  const [openModalNotice, setOpenModalNotice] = useState({
    isOpen: false,
    title: '',
    description: '',
  });
  const [formComplet, setFormComplet] = useState(false);
  const [authUserOrders, setAuthUserOrders] = useState<any>();
  const [addresses, setAddresses] = useState<any>();
  const [btnDisabled, setBtnDisabled] = useState<boolean>(true);
  const [showFormAddress, setShowFormAddress] = useState<boolean>(false);
  const [readOnly, setReadOnly] = useState<boolean>(false);

  const iconVerify = icon || <IconUser width={35} height={35} />;

  const handleToPage = (url: string, replace = true): any => {
    return navigate(url, { replace });
  };

  const handleSelectForm = (
    name: any,
    id: number,
    desName: string,
    value: string,
  ): void => {
    if (name === 'idBairro') {
      setOpenModalSelectDistrict(false);
    }
    setFormParams((field: any) => {
      return {
        ...field,
        [`${name}`]: id,
        [`${desName}`]: value,
      };
    });
  };

  const getDataUser = async (
    idUsuario: number,
    nrDDD = '',
    nrTelefone = '',
  ): Promise<void> => {
    try {
      createloading(true);

      const result: ItypeReturnApi = await api.apiMaisdelivery.auth.getDataUser(
        {
          nr_operacao: idUsuario ? 82 : 84,
          idUsuario,
          idMarketplace: dataShop.shop.idMarketplace,
          idRestaurante: dataShop.shop.idRestaurante,
          nrDDD,
          nrTelefone,
        },
      );

      if (!result.data[0] || result.data[0]?.enderecos?.length === 0) {
        setShowFormAddress(true);
      }

      if (result.data[0]?.idUsuario) {
        setReadOnly(true);
        setFormParams((fields) => {
          return {
            ...fields,
            dsNome: result.data[0]?.dsNome,
            nrDDD: result.data[0]?.nrDDD,
            nrTelefone: result.data[0]?.nrTelefone,
            dsEmail: result.data[0]?.dsEmail,
            idUsuario: result.data[0]?.idUsuario,
          };
        });

        setAddresses(result.data[0].enderecos);

        if (result.data[0].enderecos?.length > 0) {
          setShowFormAddress(false);
        }
      } else {
        setReadOnly(false);
        setFormParams((fields) => {
          return {
            ...fields,
            dsNome: '',
            dsEmail: '',
            nrLatitude: 0,
            nrLongitude: 0,
            nrLatitudeCidade: 0,
            nrLongitudeCidade: 0,
            dsRua: '',
            nrRua: '',
            dsComplemento: '',
            dsReferencia: '',
            idBairro: 0,
            dsBairro: '',
            idUsuario: 0,
            idEndereco: 0,
          };
        });

        setAddresses([]);
      }

      createloading(false);
    } catch (err: any) {
      setOpenModalSelectDistrict(false);
    } finally {
      setBtnDisabled(false);
      setFormComplet(true);
      createloading(false);
    }
  };

  const handleChangeForm = (event: any): void => {
    const { name } = event.target;
    const { value } = event.target;

    if (name === 'address') {
      if (value == 0) return;

      if (value == -1) {
        setShowFormAddress(true);
        setFormParams((field) => {
          return {
            ...field,
            idEndereco: 0,
            dsRua: '',
            nrRua: '',
          };
        });
        return;
      }
      setShowFormAddress(false);

      const objAddress = JSON.parse(value);

      setFormParams((field) => {
        return {
          ...field,
          idEndereco: objAddress.idEndereco,
          dsRua: objAddress.dsRua,
          nrRua: objAddress.nrRua,
        };
      });
      return;
    }

    setFormParams((field) => {
      return {
        ...field,
        [`${name}`]: value,
      };
    });

    if (name === 'nrTelefone') {
      if (
        onlyNumbers(formParams?.nrDDD)?.length >= 2 &&
        onlyNumbers(value)?.length == 9
      ) {
        getDataUser(0, onlyNumbers(formParams.nrDDD), onlyNumbers(value));
      }
    }
  };

  const handleListDestrict = async (idCidade: number): Promise<void> => {
    if (!idCidade) {
      return;
    }
    try {
      createloading(true);

      const result: ItypeReturnApi =
        await api.apiMaisdelivery.address.listCityDestrict({
          nr_operacao: 6,
          idCidade,
        });

      setDestrictList(result.data?.bairros);
      setOpenModalSelectDistrict(true);
      createloading(false);
    } catch (err: any) {
      setOpenModalSelectDistrict(false);
    } finally {
      createloading(false);
    }
  };

  function validateForm(data: any, typeDelivery: number): string {
    if (!data.dsNome.trim()) {
      return 'Nome é obrigatório';
    }

    if (data.nrDDD == '') {
      return 'DDD é obrigatório';
    }

    if (data.nrTelefone == '') {
      return 'Telefone é obrigatório';
    }

    if (data.nrTelefone.length != 9) {
      return 'Telefone é inválido';
    }

    if (data.dsEmail && !/\S+@\S+\.\S+/.test(data.dsEmail)) {
      return 'E-mail é obrigatório';
    }

    if (typeDelivery === 1 && !formParams.idEndereco) {
      if (data.idCidade <= 0) {
        return 'Cidade é obrigatória';
      }

      if (data.dsRua == '') {
        return 'Rua/AV é obrigatória';
      }

      if (data.nrRua == '') {
        return 'Número é obrigatória';
      }

      if (data.dsReferencia == '') {
        return 'Referência é obrigatória';
      }

      if (data.idBairro <= 0) {
        return 'Bairro é obrigatória';
      }
    }

    return '';
  }

  const handleTreatOrder = (): void => {
    const validation = validateForm(
      formParams,
      parseInt(dataOrder.idEntrega, 10),
    );

    if (validation.length > 0) {
      setOpenModalNotice({
        isOpen: true,
        title: 'Atenção',
        description: 'Todos os campos são obrigatórios',
      });
      return;
    }

    fn(formParams);
    onClose();
  };

  useEffect(() => {
    if (!isOpen) return;
    const dataLocation = getStorege('@mais/delivery/dataStateCity');

    if (dataLocation != null && typeof dataLocation === 'object') {
      setFormParams((field) => {
        return {
          ...field,
          idCidade: dataLocation.idCidade,
          dsCidade: dataLocation.dsCidade,
          dsEstado: dataShop.shop?.dsEstado,
        };
      });
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    const result = getStorege('@mais/delivery/authorization/orders');

    if (result?.idUsuario) {
      getDataUser(result?.idUsuario);

      setAuthUserOrders(result);
    }
  }, [isOpen]);

  return (
    <Modal
      open={isOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styleModal}>
        <Header children="OrderDataRegister" onClose={onClose} />

        <Grid>
          <Grid>
            <Grid container item xs={12} justifyContent="center">
              {iconVerify}
            </Grid>
            <Grid container item xs={12} justifyContent="center">
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h4"
                className={classeStyle.titleModal}
                style={{ fontWeight: '550' }}
              >
                Quase la...
              </Typography>
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className={classeStyle.textModal}
              >
                Preencha seu dados para pedido ser enviado!
              </Typography>
            </Grid>

            <Grid
              container
              item
              justifyContent="center"
              alignItems="center"
              textAlign="center"
            >
              <form className={classeStyle.form}>
                <Grid width="80%">
                  <Grid
                    container
                    item
                    justifyContent="flex-start"
                    alignItems="center"
                    textAlign="center"
                    position="relative"
                  >
                    <label className={classeStyle.labelText}>
                      Qual o número do seu celular?
                    </label>
                    <IconPhone className={classeStyle.icon} />
                    <Grid container item>
                      <Grid item xs={4} marginLeft="0px">
                        <input
                          type="text"
                          className={classeStyle.inputTextOrderData}
                          placeholder="DDD"
                          value={formParams.nrDDD}
                          name="nrDDD"
                          size={3}
                          maxLength={3}
                          onChange={handleChangeForm}
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <input
                          type="text"
                          className={classeStyle.inputTextOrderData}
                          placeholder="+ Telefone"
                          size={9}
                          maxLength={9}
                          value={formParams.nrTelefone}
                          name="nrTelefone"
                          onChange={handleChangeForm}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {formComplet && (
                    <>
                      <Grid
                        container
                        item
                        justifyContent="flex-start"
                        alignItems="center"
                        textAlign="center"
                        position="relative"
                      >
                        <label className={classeStyle.labelText}>Nome</label>
                        <IconUser className={classeStyle.icon} />
                        <input
                          type="text"
                          className={classeStyle.inputTextOrderData}
                          placeholder="Digite seu nome completo"
                          name="dsNome"
                          value={formParams.dsNome}
                          onChange={handleChangeForm}
                          readOnly={readOnly}
                        />
                      </Grid>
                      <Grid
                        container
                        item
                        justifyContent="flex-start"
                        alignItems="center"
                        textAlign="center"
                        position="relative"
                      >
                        <label className={classeStyle.labelText}>
                          Qual é seu melhor e-mail?
                        </label>
                        <IconEmail className={classeStyle.icon} />
                        <input
                          type="text"
                          className={classeStyle.inputTextOrderData}
                          placeholder="exemplo@mail.com"
                          name="dsEmail"
                          value={formParams.dsEmail}
                          onChange={handleChangeForm}
                          readOnly={readOnly}
                        />
                      </Grid>
                      {parseInt(dataOrder.idEntrega, 10) === 1 && (
                        <>
                          {addresses?.length > 0 && (
                            <Grid
                              container
                              item
                              justifyContent="flex-start"
                              alignItems="center"
                              textAlign="center"
                            >
                              <label className={classeStyle.labelText}>
                                Endereço
                              </label>
                              <select
                                className={
                                  classeStyle.inputTextOrderDataAddress
                                }
                                name="address"
                                onChange={handleChangeForm}
                              >
                                <option hidden value="0">
                                  Selecione seu endereço
                                </option>
                                {addresses.map((item: any) => (
                                  <option
                                    key={item.idEndereco}
                                    value={JSON.stringify(item)}
                                  >
                                    {item.dsRua} {item.nrRua}
                                  </option>
                                ))}
                                <option value="-1">
                                  Cadastrar um novo endereço
                                </option>
                              </select>
                            </Grid>
                          )}
                          {showFormAddress && (
                            <>
                              <Grid
                                container
                                item
                                justifyContent="flex-start"
                                alignItems="center"
                                textAlign="center"
                              >
                                <label className={classeStyle.labelText}>
                                  Cidade - UF
                                </label>
                                <Grid
                                  className={classeStyle.gridInputTextOrderData}
                                >
                                  {formParams.dsCidade}
                                </Grid>
                              </Grid>
                              <Grid
                                container
                                item
                                justifyContent="flex-start"
                                alignItems="center"
                                textAlign="center"
                              >
                                <label className={classeStyle.labelText}>
                                  Bairro
                                </label>
                                <Grid
                                  onClick={() =>
                                    handleListDestrict(formParams.idCidade)
                                  }
                                  className={classeStyle.gridInputTextOrderData}
                                >
                                  {formParams.dsBairro}
                                </Grid>
                              </Grid>
                              <Grid
                                container
                                item
                                justifyContent="flex-start"
                                alignItems="center"
                                textAlign="center"
                              >
                                <label className={classeStyle.labelText}>
                                  Nome da Rua
                                </label>
                                <input
                                  type="text"
                                  className={
                                    classeStyle.inputTextOrderDataAddress
                                  }
                                  name="dsRua"
                                  value={formParams.dsRua}
                                  onChange={handleChangeForm}
                                />
                              </Grid>
                              <Grid
                                container
                                item
                                justifyContent="flex-start"
                                alignItems="center"
                                textAlign="center"
                              >
                                <label className={classeStyle.labelText}>
                                  Número
                                </label>
                                <input
                                  type="text"
                                  className={
                                    classeStyle.inputTextOrderDataAddress
                                  }
                                  value={formParams.nrRua}
                                  name="nrRua"
                                  onChange={handleChangeForm}
                                />
                              </Grid>
                              <Grid
                                container
                                item
                                justifyContent="flex-start"
                                alignItems="center"
                                textAlign="center"
                              >
                                <label className={classeStyle.labelText}>
                                  Complemento
                                </label>
                                <input
                                  type="text"
                                  className={
                                    classeStyle.inputTextOrderDataAddress
                                  }
                                  value={formParams.dsComplemento}
                                  name="dsComplemento"
                                  onChange={handleChangeForm}
                                />
                              </Grid>
                              <Grid
                                container
                                item
                                justifyContent="flex-start"
                                alignItems="center"
                                textAlign="center"
                              >
                                <label className={classeStyle.labelText}>
                                  Referência
                                </label>
                                <input
                                  type="text"
                                  className={
                                    classeStyle.inputTextOrderDataAddress
                                  }
                                  value={formParams.dsReferencia}
                                  name="dsReferencia"
                                  onChange={handleChangeForm}
                                />
                              </Grid>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                  <Grid marginTop={2}>
                    <Button
                      className={classeStyle.btnModal}
                      type="button"
                      variant="contained"
                      onClick={() => handleTreatOrder()}
                      disabled={btnDisabled}
                    >
                      Continuar
                      <IconArrowRight className={classeStyle.iconArrow} />
                    </Button>
                  </Grid>
                  <Grid>
                    <p>ou</p>
                  </Grid>
                  <Grid>
                    <Button
                      className={classeStyle.btnLink}
                      type="button"
                      variant="contained"
                      onClick={() =>
                        handleToPage(
                          `/sign/in/${window.btoa(
                            'requestProgress',
                          )}/${window.btoa(dataShop.shop.idRestaurante)}`,
                          false,
                        )
                      }
                    >
                      Fazer login
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Grid>
        <ListCenterOrder
          open={openModalSelectDistrict}
          onClose={() => setOpenModalSelectDistrict(false)}
          title="Selecione o Bairro"
          dataList={destrictList}
          type="bairros"
          onSelect={(data) =>
            handleSelectForm(
              'idBairro',
              data.idBairro,
              'dsBairro',
              data.dsBairro,
            )
          }
        />
        <ModalMessage
          open={openModalNotice.isOpen}
          onClose={() =>
            setOpenModalNotice({
              isOpen: false,
              title: '',
              description: '',
            })
          }
          title={openModalNotice.title}
          description={openModalNotice.description}
          primaryText="Ok"
          primaryAction={() => ''}
        />
      </Box>
    </Modal>
  );
};

export default OrderDataRegister;
